import type {BasePanel} from '@Components/panel/panel.types';

export const PANEL_ID = 'homepage-create-popup-panel';
export interface HomepageCreatePopupPanelProps extends BasePanel {
  onClickCreateWithAI?: VoidFunction;
  onClickCreateDesign?: VoidFunction;
  onClickCreateSocialMediaPost?: VoidFunction;
  onClickCreateEmail?: VoidFunction;
  onClickCreateEvent?: VoidFunction;
  includeHeader?: boolean;
  /**
   * When true, the panel adds bottom spacing while the tracking-consent bar is visible so its
   * options are not covered by it. Only the bottom-anchored create-options modal sets this.
   */
  avoidBottomConsentForm?: boolean;
}
